export enum ContentViewType {
  Grid,
  List,
  Detailed,
  Calendar,
}
